import axios from "axios";
import { initializeApp } from "firebase/app";
import { getMessaging, getToken } from "firebase/messaging";
import { DeviceUUID } from "device-uuid";
import { Token } from "utils/helpers/encrypt-decrypt-user";

const firebaseApp = initializeApp({
  // apiKey: "AIzaSyA5hg7Y4XUPj6revUrIIWcsqjzl2xoJVFk",
  // authDomain: "izon-63150.firebaseapp.com",
  // projectId: "izon-63150",
  // storageBucket: "izon-63150.appspot.com",
  // messagingSenderId: "111888808443",
  // appId: "1:111888808443:web:32704579578e7d18aab35e",
  // measurementId: "G-2RMKH4F87B",
  apiKey: "AIzaSyC7PzA0A4lmh8bthUPKnd6-cxVuHYc09A4",
  authDomain: "izone-fae6b.firebaseapp.com",
  projectId: "izone-fae6b",
  storageBucket: "izone-fae6b.firebasestorage.app",
  messagingSenderId: "712577739229",
  appId: "1:712577739229:web:f5a3097307fb402e14ae34",
  measurementId: "G-P67QNSCDK8"
});
if (firebaseApp) {
}

/**
 * disable for localhost
 */
export const messaging = getMessaging(firebaseApp);
// export const messaging = "";

export const getTokenAsync = () => {
  return getToken(messaging, {
    vapidKey:
      // "BMEj4K9MMjjTAn2elTXUQUQLqBVg25m4WNRw8BQky_2KTGVUROOdYa5ML6V5bVP_OmHuTxH369GMvTGo5JYpxFs",
      "BKKURllNCegHbO_e2ikJ1zkOXptshyFr3vJDqSIO0Nix2sKPHTKyVPasDyI7G923JmhkHBTad15uVw6Q0gcrwAQ",
  })
    .then((currentToken) => {
      if (currentToken) {
        // Track the token -> client mapping, by sending to backend server
        // show on the UI that permission is secured
        var uuid = new DeviceUUID().get();
        if (Token.Get() !== null)
          axios.post(
            process.env.REACT_APP_API_URL + "api/add-firebase-token",
            {
              firebase_token: currentToken,
              device_id: uuid,
              platform: "Web",
              version: `${process.env.REACT_APP_VERSION}`,
            },
            {
              headers: {
                Authorization: `Bearer ${Token.Get()}`,
              },
            }
          );
        return currentToken;
      }
    })
    .catch((err) => {
      console.log("Error firebase", err);
      // catch error while creating clieernt token
    });
};
